/**
 * Lenient email validation - allows UTF-8 characters in both local and domain parts.
 * Used for login and general validation to support existing users with special characters.
 */
export const isValidEmail = (email: string) => {
  // Basic email structure validation that allows UTF-8 characters
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Strict email validation - ASCII-only for both local and domain parts.
 * Used for new user registration to prevent special characters.
 */
export const isValidEmailStrict = (email: string) => {
  // RFC 5322 compliant email regex with ASCII-only restriction
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(email);
};
